import {
  MEETING_HISTORY,
  CREATE_MEETING,
  POC_LIST_DROPDOWN,
  MEETING_BY_ID,
  CANCEL_MEETING,
  COMPLETE_MEETING
} from "./type";

const initialState = {
  meetingList: [],
  meetingData: {},
  pocList: [],
  meetingById: {},
  cancel: [],
  complete: []
}

const meetingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MEETING_HISTORY:
      return {
        ...state,
        meetingList: payload,
      };
    case CREATE_MEETING:
      return {
        ...state,
        meetingData: payload,
      };
    case POC_LIST_DROPDOWN:
      return {
        ...state,
        pocList: payload,
      };
      case MEETING_BY_ID:
      return {
        ...state,
        meetingById: payload,
      };
      case CANCEL_MEETING:
      return {
        ...state,
        cancel: payload,
      };
      case COMPLETE_MEETING:
      return {
        ...state,
        complete: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default meetingReducer;